import { render, staticRenderFns } from "./CreditBalance.vue?vue&type=template&id=66f098f4"
import script from "./CreditBalance.vue?vue&type=script&lang=js"
export * from "./CreditBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports